import axios from "axios";
import { useNavigate } from "react-router-dom";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const login = async (email, password) => {
  const query = {
    UserName: email,
    Password: password,
  };

  const response = await axios.post(
    `${API_BASE_URL}/api/Account/LoginUser`,
    query,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  
  const data = response.data;
  const token = data?.Data?.Token; 
  if (token) {
    localStorage.setItem("token", token);
    
  }
 
  return data;
};

export default login;